import { render, staticRenderFns } from "./JobComments.vue?vue&type=template&id=440a239a&scoped=true"
import script from "./JobComments.vue?vue&type=script&lang=js"
export * from "./JobComments.vue?vue&type=script&lang=js"
import style0 from "./JobComments.vue?vue&type=style&index=0&id=440a239a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a239a",
  null
  
)

export default component.exports